import React, { Component } from 'react';
import styled from 'styled-components';
import debounce from 'lodash.debounce';

import Image from 'partials/Image';
import Container from 'partials/Container';
import ImageOverlay from 'partials/ImageOverlay';
import GridElement from 'partials/GridElement';

import Media, { ScreenWidth } from 'css/Media';

class TwoImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
        }
    }

    componentWillMount() {
        this.checkScreenSize();
    }

    componentDidMount() {
        window.addEventListener('resize',debounce(this.checkScreenSize.bind(this)),500);
    }

    componentWillUnmount() {
        window.removeEventListener('resize',this.checkScreenSize());
    }

    checkScreenSize() {
        let isMobile = false;

        if (ScreenWidth.lessThan('s')) {
            isMobile = true;
        }
        this.setState({isMobile: isMobile});
    }

    render() {
        const { isMobile } = this.state;
        const { data } = this.props;

        return (
            <ModuleWrapper>
                <Container grid>
                    <GridElement
                        colStart={{default: 1, s: 1}}
                        colEnd={{default: 8, s: 10}}
                        rowStart={{default: 1, s: 3}}
                        rowEnd={{default: 2, s: 6}}
                        rowSpan={!isMobile}
                    >
                        <ImageOverlay image={data.image_one}>
                            <Image 
                                image={data.image_one}
                                key={data.image_one.id} 
                            />
                        </ImageOverlay>
                    </GridElement>
                    <GridElement
                        colStart={{default: 1, s: 13}}
                        colEnd={{default: 8, s: 22}}
                        rowStart={{default: 3, s: 1}}
                        rowEnd={{default: 4, s: 4}}
                        rowSpan={!isMobile}
                    >
                        <ImageOverlay image={data.image_two}>
                            <Image 
                                image={data.image_two}
                                key={data.image_two.id} 
                            />
                        </ImageOverlay>
                    </GridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default TwoImages;

const ModuleWrapper = styled.div`
    margin: ${props => props.theme.spacing.elementXS} 0 0;
   
   .container {
        img {
            max-width: none;
            width: 100%;
            margin-bottom: 50px;

            ${Media.greaterThan('s')`
                margin-bottom: 0;
            `}
        }

        ${Media.greaterThan('s')`
            grid-template-rows: repeat(5, 1fr);
        `}
   }

    ${Media.greaterThan('s')`
        margin: ${props => props.theme.spacing.blockM} 0 ${props => props.theme.spacing.blockL};
    `}
`